import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalhesProcesso } from '../../../models/detalhes-processo';
import { ProcessoService } from '../../../services/processo-service';

@Component({
  selector: 'app-visualizar-processo',
  templateUrl: './visualizar-processo.component.html',
  styleUrls: ['./visualizar-processo.component.css'],
  standalone: false
})
export class VisualizarProcessoComponent {
  loading = false;
  processo = new DetalhesProcesso();
  id = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoServico: ProcessoService
  ){
    this.id = this.route.snapshot.params['id'];
    this.buscarProcessoPorId(this.id);
  }

  buscarProcessoPorId(id: number){
    this.loading = true;
    this.processoServico.buscarPorId(id).subscribe(response => {
      this.loading = false;
      if(response.sucesso){
        this.processo = response.dados;
      }
    }, _ => this.loading = false);
  }

  imprimir(){
    window.print();
  }

  voltar(){
    this.router.navigate(['/juridico/processo']);
  }
}
